import DOMPurify from 'dompurify';

// Plain-text preview of a rich-text HTML field, for places that can't render
// HTML (DataGrid cells, CSV/PDF exports, list search) — strips all tags,
// collapses whitespace. Safe for a value that may or may not contain HTML.
export const stripHtml = (html: string | null | undefined): string => {
  if (!html) return '';
  const text = DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  return text.replace(/\s+/g, ' ').trim();
};
